import {
  Button,
  Flex,
  IconInfoSolid,
  Modal,
  Pill,
  Spinner,
  Text,
  TextInput,
  Tooltip,
} from "@instructure/ui";
import { useTranslation } from "react-i18next";
import { useContext, useState } from "react";
import { EmbeddedDashboardService } from "../../../../../services/EmbeddedDashboardService";
import { ApDataContext } from "../../../../../views/Plan";
import { Card } from "../../../../Card";
import {
  ERROR,
  useNotification,
} from "../../../../CustomHooks/NotificationProvider";
import { EMBEDDED } from "../../utils";

const EmbeddedDashTemplateCard = ({ templateFields }) => {
  const { sectionIndex, measureIndex, handleCreateMeasure } =
    useContext(ApDataContext);
  const { t } = useTranslation();
  const showNotification = useNotification();
  const [dashboardUrl, setDashboardUrl] = useState("");
  const [saving, setSaving] = useState(false);

  const handleEmbeddedVerification = () => {
    setSaving(true);
    const dashboardAdd = {
      name: templateFields.name,
      url: dashboardUrl,
      description: templateFields.description,
      sequence: measureIndex,
    };

    const dashboard = {
      planId: null,
      sectionId: null,
      embeddedDatalink: dashboardAdd,
    };

    EmbeddedDashboardService.createEmbeddedDashboard(dashboard)
      .then((newMeasure) => {
        newMeasure = { ...newMeasure, type: EMBEDDED };
        handleCreateMeasure(newMeasure, sectionIndex, measureIndex);
        setSaving(false);
      })
      .catch(() => {
        showNotification(
          t("notifications.assessments.createAssessmentError"),
          ERROR
        );
        setSaving(false);
      });
  };

  return (
    <Card style={{ backgroundColor: "#FFFFFF", padding: "0" }}>
      <Flex wrap="wrap" padding="small" gap="x-small">
        <Flex.Item size="100%">
          <Pill color="info" themeOverride={{ maxWidth: "30rem" }}>
            {t("embeddedDashboard.embeddedDashboard")}
          </Pill>
        </Flex.Item>
        <Flex.Item size="100%">
          <Text as="div" size="small">
            <Text weight="bold" size="small">
              {t("assessment.name")}:{" "}
            </Text>
            {templateFields.name}
          </Text>
        </Flex.Item>
        <Flex.Item size="100%">
          <Text as="div" size="small" lineHeight="double">
            <Text weight="bold" size="small">
              {t("embeddedDashboard.description")}:{" "}
            </Text>
            {templateFields.description}
          </Text>
        </Flex.Item>
        <Flex.Item size="100%">
          <TextInput
            renderLabel={
              <Text size="small">
                {t("embeddedDashboard.dashURL")}{" "}
                <Text size="small" color="secondary" fontStyle="italic">
                  ({t("form.optional")}){" "}
                </Text>
                <Tooltip
                  renderTip="You may attach dashboard when viewing results"
                  placement="end"
                >
                  <IconInfoSolid color="brand" />
                </Tooltip>
              </Text>
            }
            size="small"
            defaultValue={dashboardUrl}
            onBlur={(e) => setDashboardUrl(e.target.value)}
          />
        </Flex.Item>
      </Flex>
      <Modal.Footer>
        <Button
          color="primary"
          size="small"
          onClick={handleEmbeddedVerification}
          disabled={saving}
        >
          {saving ? (
            <Spinner renderTitle={t("global.pleaseWait")} size="x-small" />
          ) : (
            t("global.save")
          )}
        </Button>
      </Modal.Footer>
    </Card>
  );
};

export default EmbeddedDashTemplateCard;
